<template>
  <div class="contactApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" :style="'min-height:'+curHeight+'px'">
    <div class="banner">
      <img src="~assets/images/contact.png"/>
      <p>Contact Us & Business Inquiries</p>
    </div>
    <div class="txt">
      <div style="height: 12px"></div>
      <p>编辑单位：《笙隆國際》编辑部</p>
      <p style="padding-bottom: 12px">Editorial Unit: Editorial Department of Shenglong International</p>
      <p>地址: 香港九龙尖沙咀广东道17号海港城环球金融中心南座13A楼06室</p>
      <p style="padding-bottom: 12px">Room 06, 13A/F, South Tower, Harbour City Global Financial Centre, 17 Canton Road, Tsim Sha Tsui, Kowloon, Hong Kong</p>
      <p>电话:(00852)2206 0092</p>
      <p style="padding-bottom: 12px">Telephone :(00852)2206 0092</p>
      <p>传真: (00852)3003 0133</p>
      <p style="padding-bottom: 12px">Fax: (00852)3003 0133</p>
      <p>邮编：999077</p>
      <p style="padding-bottom: 12px">Postal Code: 999077</p>
      <p>香港灣仔莊士敦道178-186號華懋荘士敦廣場12楼1201室</p>
      <p style="padding-bottom: 12px">Publication Address: Room 1201, 12/F, Chinachem Johnston Plaza, 178-186 Johnston Road, Wanchai, Hong Kong.</p>
      <p>E-mail：senlointernationa@163.com</p>
      <p>E-mail：senlointernationa@163.com</p>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      }
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .contactApp .el-message-box{
    width:30%
  }
  .contactApp{
    max-width:750px;
    margin:0 auto;
    background:#fff;
  }
  .contactApp .banner{
    position: relative;
    width:100%;
  }
  .contactApp .banner img{
    display:block;
    width:100%
  }
  .contactApp .banner p{
    color:#fff;
    font-size:18px;
    font-weight:bold;
    position: absolute;
    top:50%;
    width:100%;
    text-align:center;
    transform: translateY(-50%);
    letter-spacing: 5px
  }

  .contactApp .txt{
    width:94%;
    margin:0 auto
  }
  .contactApp .txt p{
    font-size:16px;
    line-height:22px
  }
</style>